import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPrivacyOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM3.78363 11.25C4.10248 7.7118 6.65519 4.81774 10.0206 3.98899C8.39765 5.99624 7.37091 8.50693 7.21171 11.25H3.78363ZM12 4.03017C10.12 5.90303 8.8998 8.4349 8.7146 11.25H15.2854C15.1002 8.4349 13.88 5.90303 12 4.03017ZM15.2854 12.75H8.71459C8.89977 15.5651 10.12 18.097 12 19.9699C13.88 18.097 15.1002 15.5651 15.2854 12.75ZM13.9795 20.011C15.6024 18.0037 16.6291 15.4931 16.7883 12.75H20.2164C19.8975 16.2882 17.3449 19.1822 13.9795 20.011ZM16.7883 11.25C16.6291 8.50693 15.6023 5.99624 13.9794 3.98899C17.3448 4.81774 19.8975 7.7118 20.2164 11.25H16.7883ZM3.78363 12.75H7.2117C7.37088 15.4931 8.39759 18.0037 10.0205 20.011C6.65514 19.1822 4.10247 16.2882 3.78363 12.75Z",
		fill: "currentColor"
	})
});
export { SvgIconPrivacyOpen as ReactComponent };
